<template>

    <div v-if="loading" class="unsub">
        <div class="p-30">
            <v-loader v-if="loading" size="lg" />
        </div>
    </div>

    <div v-else class="unsub">
        <div class="unsub-body" :class="{ success: success, danger: error }">
            <span v-if="error">{{ error }}</span>
            <span v-else-if="success === 'unsubscribed'">You are now unsubscribed from notifications for list:<br>{{ group.display_name }}</span>
            <span v-else-if="success === 'unsubscribed-all'">You are now unsubscribed from all notifications.</span>
            <span v-else-if="success === 'resubscribed'">You are now subscribed to notifications for list:<br>{{ group.display_name }}</span>
        </div>
        <div v-if="success" class="unsub-footer">
            <p v-if="success == 'unsubscribed' || success == 'resubscribed'"><a href="#" @click.prevent="unsubscribeAll">Unsubscribe from all notifications &rarr;</a></p>
            <p v-if="success !== 'resubscribed'"><a href="#" @click.prevent="resubscribe">Resubscribe &rarr;</a></p>
        </div>
    </div>

</template>

<style scoped lang="scss">

    .unsub {
        align-items: center;
        display: flex;
        flex-direction: column;
        justify-content: center;
        padding-top: 60px;
        text-align: center;
        .unsub-body {
            @include font-semibold(14px);
            border: 3px solid $color-rule;
            line-height: 1.8em;
            padding: 30px 40px;
            &.success {
                border-color: $color-success;
                color: $color-success;
            }
            &.danger {
                border-color: $color-danger;
                color: $color-danger;
            }
        }
        .unsub-footer {
            @include font-bold(10px);
            padding: 30px;
            text-transform: uppercase;
            p {
                margin: 0 0 10px 0;
            }
            a {
                color: $color-text;
                opacity: 0.5;
                text-decoration: none;
                transition: opacity .3s;
                &:hover {
                    opacity: 1;
                }
            }
        }
    }

</style>

<script>

import CampaignMessageApi from '@api/CampaignMessageApi';
import CustomerApi from '@api/CustomerApi';

export default {

    data() {
        return {
            loading: true,
            error: null,
            success: false,
            group: null,
        }
    },

    mounted() {
        if (this.$route.params.unsubscribe_token) {
            this.unsubscribe();
        } else {
            this.loading = false;
            this.error = 'An unsubscribe token is required.';
        }
    },

    methods: {

        unsubscribe() {
            this.loading = true;
            let params = { unsubscribe_token: this.$route.params.unsubscribe_token }
            CampaignMessageApi.unsubscribe(this.$route.params.message_id, params)
                .then((response) => {
                    this.loading = false;
                    this.error = null;
                    this.success = 'unsubscribed';
                    this.group = response.data.data;
                }, (error) => {
                    this.loading = false;
                    this.error = error.response.data.message;
                });
        },

        unsubscribeAll() {
            this.loading = true;
            let params = { unsubscribe_token: this.$route.params.unsubscribe_token }
            CustomerApi.unsubscribe(this.$route.params.customer_id, params)
                .then((response) => {
                    this.loading = false;
                    this.error = null;
                    this.success = 'unsubscribed-all';
                }, (error) => {
                    this.loading = false;
                    this.error = error.response.data.message;
                });
        },

        resubscribe() {
            this.loading = true;
            let params = { unsubscribe_token: this.$route.params.unsubscribe_token }
            CampaignMessageApi.resubscribe(this.$route.params.message_id, params)
                .then((response) => {
                    this.loading = false;
                    this.error = null;
                    this.success = 'resubscribed';
                    this.group = response.data.data;
                }, (error) => {
                    this.loading = false;
                    this.error = error.response.data.message;
                });
        },

    },

}

</script>